import type { CountryCallingCode } from 'libphonenumber-js';

export const formatTemplate = (
  template: string,
  countryCallingCode: CountryCallingCode,
  placeholder = '0'
) => {
  let used = 0;
  const countryCallingCodeChars = ('+' + countryCallingCode).split('');

  return template.replace(/x/g, () => {
    if (used < countryCallingCodeChars.length) {
      return countryCallingCodeChars[used++];
    }
    return placeholder;
  });
};
